// app/javascript/controllers/incoming_invoice_line_calculator_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "billingModel",
    "unitPrice",
    "quantity",
    "percentageRate",
    "discountPercent",
    "vatRate",
    "lineTotal"
  ]

  calculate() {
    if (!this.hasUnitPriceTarget || !this.hasQuantityTarget || !this.hasLineTotalTarget) return

    const unitPrice = this.numberValue(this.unitPriceTarget.value)
    const quantityInput = this.numberValue(this.quantityTarget.value)
    const quantity = quantityInput > 0 ? quantityInput : 1
    const percentageRate = this.hasPercentageRateTarget ? this.numberValue(this.percentageRateTarget.value) : 0
    const discountPercent = this.hasDiscountPercentTarget ? this.numberValue(this.discountPercentTarget.value) : 0
    const billingModel = this.hasBillingModelTarget ? this.billingModelTarget.value : ""

    const percentageBilling = billingModel === "percentage" || percentageRate > 0

    let subtotal = unitPrice * quantity

    if (percentageBilling) {
      subtotal = unitPrice * (percentageRate / 100) * quantity
    }

    if (discountPercent > 0) {
      subtotal -= subtotal * (discountPercent / 100)
    }

    this.lineTotalTarget.value = subtotal.toFixed(2)
  }

  numberValue(value) {
    if (!value) return 0
    return Number(String(value).replace(",", ".")) || 0
  }
}